import GridTagsComp from '@/components/GridTagsComp'
import { getPosts } from '@/contentful/getPosts'
import { getTag, getTags } from '@/contentful/getTags'
import PostCard from '@/src/components/Posts/PostCard'
import Section from '@/src/components/Section'
import { setMetaTags } from '@/src/components/utils/manage-tags'
import { isHot97 } from '@/src/dictionary'
import Head from 'next/head'
import { useRouter } from 'next/router'

export const getServerSideProps = async (context: any) => {
    const tagInfo = getTag(context.params.tagId)
    if (!tagInfo) return { notFound: true }

    const host = context.req.headers.host
    const posts = await getPosts(context.params.tagId, 15, null, null)
    const tags = getTags()

    let featured = null

    if (posts.length > 0) {
        featured = posts.shift()
    }

    return {
        props: {
            tagInfo,
            posts,
            featured,
            tags,
            host
        },
    }
}

interface TagsProps {
    tagInfo?: any,
    posts: any,
    featured: any,
    tags: any[],
    host: any
}

function Tag({ tagInfo, posts, featured, tags, host }: TagsProps) {

    const router = useRouter()

    return (
        <div className='mt-6'>
            <Head>
                {setMetaTags(host, { tag: tagInfo }, router.asPath)}
            </Head>
            <Section
                key={tagInfo?.name}
                title={tagInfo?.name}
            > 
             <PostCard 
                post={featured}
                imageWrapperStyle='h-full w-full transition-opacity opacity-0 duration-[1s] object-cover'
                articleStyle={`${isHot97() ? 'bg-black text-white' : 'bg-white text-black'} border-none flex flex-col justify-start max-w-full items-center p-0 mb-0`}
                contentLength={350}
            />
            </Section>
            <GridTagsComp tags={tags} posts={posts} tagName={tagInfo?.name} />
        </div>
    )

}

export default Tag
